// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"362":"c60721b4","418":"a9931665"}[chunkId] + ".css";
};